import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectsRedirectRoute: InvariantJiraRoute = {
	name: 'projects-redirect',
	path: '/projects/:projectKey',
	query: ['selectedItem!=(.+)'],
	exact: true,
};
